import { IWithWorksheetInjectedProps, WorksheetAssociatedTestSection } from 'Components/Worksheets/Core';
import { valueOrDefault } from 'Lib/Any';
import { pipe } from 'Lib/Hooks/Selectors';
import React from 'react';
import { useSelector } from 'react-redux';
import { Checkbox, Field, Label } from '../../../../../Core';
import { withInjectedProps } from '../../../../../Core/InjectedPropsContext';
import { FieldSet, ListFieldSection, SectionGroup } from '../../../../../Layout';
import AsLiquidLimitOnePointTrialSection from './LiquidLimitOnePointTrialSection';

let AsLiquidLimitOnePointDeterminationSection: React.FC<IWithWorksheetInjectedProps> = ({
  createWorksheetSelector,
}) => {
  const determinationPerformed = useSelector(
    pipe(createWorksheetSelector!('NonPlastic'), valueOrDefault(false), (np) => !np)
  );
  return (
    <>
      <SectionGroup heading="Liquid Limit Determination">
        <ListFieldSection>
          <FieldSet>
            <Label>Material Suitability</Label>
            <Field input={<Checkbox />} label="Result cannot be obtained (E.g. slips in cup)" name="NonPlastic" />
          </FieldSet>
        </ListFieldSection>
        {determinationPerformed && (
          <>
            <AsLiquidLimitOnePointTrialSection />
            <WorksheetAssociatedTestSection
              heading="AS 1289.2.1.1 Moisture Content"
              name="EmbeddedWaterContent"
              testType="Moisture Content"
              associatedTestModel={{
                measured: true,
              }}
            />
          </>
        )}
      </SectionGroup>
    </>
  );
};

AsLiquidLimitOnePointDeterminationSection = withInjectedProps(AsLiquidLimitOnePointDeterminationSection);

export { AsLiquidLimitOnePointDeterminationSection };
export default AsLiquidLimitOnePointDeterminationSection;
